module.exports = __webpack_public_path__ + "static/img/usBottom6.2557158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom6.png
// module id = tGa1
// module chunks = 2